import Cookies from 'js-cookie';

export const UB_REF_QUERY_PARAM_VALUE = 'plans_comparison_summary';

const SUBSCRIBE_FROM_PAGE_COOKIE = 'subscribe_from_page';

export const removeSubscribeFromPageCookie = () => {
    Cookies.remove(SUBSCRIBE_FROM_PAGE_COOKIE);
};

export const STARTER_PLAN_CHECKOUT_URL =
    'https://www.udemy.com/subscription-checkout/express/?product_type=CONSUMERSUBSCRIPTION_VALUE_PLAN&plan_preference=YEAR';
export const PERSONAL_PLAN_CHECKOUT_URL =
    'https://www.udemy.com/subscription-checkout/express/?product_type=CONSUMERSUBSCRIPTION&plan_preference=YEAR';
export const PERSONAL_PLAN_UPGRADE_URL =
    'https://www.udemy.com/subscription-checkout/upgrade/?upgrade_type=tier&product_type=CONSUMERSUBSCRIPTION';

// HACK HACK HACK - this should only ever be used to format prices for the team plan v1 fallback
export const TEAM_PLAN_V1_FALLBACK_CURRENCY_FORMATTER = {
    currency: 'usd',
    symbol: '$',
    locale: 'en_US',
    decimal: '.',
    group: ',',
    pattern: '!#,##0.00',
    scale: 2,
};
